import { createFileRoute } from '@tanstack/react-router'

import { AgreementsSettingsPage } from '@/features/settings/section-pages'

export const Route = createFileRoute('/_app/settings/agreements')({
  component: AgreementsSettingsPage,
})
